module.exports = __webpack_public_path__ + "2e55e9cf643a3341ce2628179a3f555d.jpg";